var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.value === true || _vm.value === 'Y' || _vm.value === 'Yes')?_c('v-icon',[_vm._v(" mdi-check ")]):(_vm.value === false || _vm.value === 'N' || _vm.value === 'No')?_c('v-icon',[_vm._v(" mdi-close ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }